export default __webpack_public_path__ + "static/media/intel-gold-2.9da911ff.png";